import React from 'react';

import Image from '../../Commons/Image/Image';
import NEUQUEN from '../../../assets/swiss-medical-center/centro_neuquen.jpg';

import styles from './SwissMedicalNeuquen.module.scss';

const SwissMedicalNeuquen = () => {
  return (
    <div className={styles.swiss_medical_neuquen}>
      <h3>Neuquén</h3>
      <p>
        <strong className={styles.swiss_medical_neuquen__redText}>Dirección:</strong> Fotherimgham
        155
      </p>
      <p>
        <strong className={styles.swiss_medical_neuquen__redText}>Conmutador:</strong> 0299-4434730
      </p>
      <p>
        <strong className={styles.swiss_medical_neuquen__redText}>
          Directo asociados Swiss Medical Medicina Privada:
        </strong>{' '}
        0299-4433487
      </p>
      <p className={styles.swiss_medical_neuquen__redText}>info@sanlucassalud.com.ar</p>
      <Image
        src={NEUQUEN}
        alt='Sede Olivos'
        title='Olivos'
        classes={styles.swiss_medical_neuquen__image}
      />
      <p>
        <strong className={styles.swiss_medical_neuquen__redText}>Atención Programada</strong>
      </p>
      <p className={styles.swiss_medical_neuquen__redText}>Lunes a viernes</p>
      <ul>
        <li>Cardiología</li>
        <li>Clinica médica</li>
        <li>Dermatología</li>
        <li>Diagnóstico por imágenes</li>
        <li>Fonoaudiología</li>
        <li>Ginecología y obstetricia</li>
        <li>Kinesiología</li>
        <li>Laboratorio de alta complejidad</li>
        <li>Nutrición</li>
        <li>Odontología</li>
        <li>Oftalmología</li>
        <li>Otorrinolaringología</li>
        <li>Ortopedia y traumatología</li>
        <li>Psicología</li>
      </ul>
    </div>
  );
};

export default SwissMedicalNeuquen;
